import { useState } from 'react';
import { Box, IconButton, Tooltip, FormControl, TextField } from '@mui/material';
import { HelpOutlineOutlined as QuestionIcon } from '@mui/icons-material';
import { Text } from 'mbd-components/text';
import { BrandedDialog } from 'mbd-components/branded-dialog';
import { colors } from 'helper/colors';

export function CountField({
  heading, 
  headingColor, 
  step, 
  value, 
  onChange, 
  horizontal, 
  minWidth, 
  showExplanation, 
  explanationTitle, 
  explanationDescription}) {
  
  const [openInfoDialog, setOpenInfoDialog] = useState(false);
  const [infoDialogTitle, setInfoDialogTitle] = useState('');
  const [infoDialogText, setInfoDialogText] = useState([]);

  return (
    <Box sx={{display:'flex', flexDirection: horizontal ? 'row' : 'column', alignItems: horizontal ? 'center' : 'flex-start'}} >
    <BrandedDialog 
      open={openInfoDialog} 
      title={infoDialogTitle} 
      texts={infoDialogText} 
      onClose={() => setOpenInfoDialog(false)} 
      buttonText="Got It 👀 "
    />
    <Text noWrap={true} variant='fieldHeading' color={headingColor || 'brand-light'} sx={{minWidth: minWidth || 170}}>
        {heading}
        {
          showExplanation &&
          <IconButton
            ml={1}
            onClick={() => {setOpenInfoDialog(true); 
              setInfoDialogTitle(explanationTitle); 
              setInfoDialogText(explanationDescription)
            }}
          >
            <Tooltip title={`What is ${heading.toLowerCase()}?`}>
              <QuestionIcon sx={{color:colors['gray-lighter']}}/>
            </Tooltip>
          </IconButton>
        }
    </Text>
    <FormControl fullWidth variant="outlined">
      <Box display="flex" alignItems="center" gap={1} sx={{marginLeft: horizontal ? 2 : 0, marginTop: horizontal ? 0 : 2}}>
        <TextField
          type="number"
          value={value}
          onChange={onChange}
          variant='outlined'
          step={step ? step : 1}
          inputProps={{
            min: 0,
            inputMode: 'numeric',
            pattern: '[0-9]*',
            style: { textAlign: 'center' } // Center align the input text
          }}
          
          placeholder={'not set'}
          sx={{width: 100}}
        />
      </Box>
    </FormControl>
  </Box>
  )

}